import SpreeAPIOrderAdapter from './ams-adapters/spree-api-order-adapter';
import APP_ROUTES from '../constants/app-routes';

const request = require('superagent');

const CheckoutAPI = {
    next: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;
        sanitizedQueryParams.zone = params.zone;

        return request
        // eslint-disable-next-line max-len
            .patch(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/checkout/next?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types`)
            .set('X-Spree-Order-Token', params.token)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams)
            .then((response) => {
                response.body = SpreeAPIOrderAdapter.processItem(response.body);
                return response;
            });
    },

    update: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;

        return request
        // eslint-disable-next-line max-len
            .patch(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/checkout?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types`)
            .set('X-Spree-Order-Token', params.token)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams)
            .send(params.formData)
            .then((response) => {
                response.body = SpreeAPIOrderAdapter.processItem(response.body);
                return response;
            });
    },

    complete: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;
        sanitizedQueryParams.zone = params.zone;

        return request
            // eslint-disable-next-line max-len
            .patch(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/checkout/complete?include=line_items,variants,variants.images,variants.product.images,billing_address,shipping_address,user,payments,shipments,promotions,shipments.shipping_rates,line_items.data_extras,variants.product.data_extra_types`)
            .set('X-Spree-Order-Token', params.token)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams)
            .then((response) => {
                response.body = SpreeAPIOrderAdapter.processItem(response.body);

                return response;
            });
    },

    getPaymentMethods: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;

        return request
            .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/checkout/available_payment_methods`)
            .set('X-Spree-Order-Token', params.token)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams)
            .then((response) => response);
    },

    getRedsysInfo: (params) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = params.locale;
        sanitizedQueryParams.url_ok = `${window.location.origin}${APP_ROUTES.checkout.redsysRedirectOk}`;
        sanitizedQueryParams.url_ko = `${window.location.origin}${APP_ROUTES.checkout.redsysRedirectKo}`;

        return request
            .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/checkout/redsys_params`)
            .set('X-Spree-Order-Token', params.token)
            .set('Content-Type', 'application/vnd.api+json')
            .query(sanitizedQueryParams)
            .then((response) => response);
    },
};

export default CheckoutAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/checkout.js
 **/